import React, { useEffect, useState } from "react";
import PromoForm from "./PromoForm";
import PromoSuccess from "./PromoSuccess";
import { PROMO_CONFIG } from "./promo.config";

const PromoPopup = () => {
  const [step, setStep] = useState(1);
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (!PROMO_CONFIG.enabled) return;

    if (
      PROMO_CONFIG.showOncePerSession &&
      sessionStorage.getItem("promo_shown")
    )
      return;

    const timer = setTimeout(() => {
      setVisible(true);
      sessionStorage.setItem("promo_shown", "true");
    }, PROMO_CONFIG.delay);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const closePopup = () => setVisible(false);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center"
      onClick={closePopup} // 👈 klik luar = close
    >
      <div
        className="relative bg-white max-w-3xl w-full grid grid-cols-2"
        onClick={(e) => e.stopPropagation()} // 👈 stop close saat klik popup
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={closePopup}
          className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl font-bold"
        >
          ✕
        </button>

        {/* STEP 1 */}
        {step === 1 && (
          <>
            <div className="p-10">
              <h2 className="text-3xl font-bold mb-4">
                Mau Diskon 10% Khusus Untuk Kamu?
              </h2>
              <p className="mb-6">
                Diskon spesial untuk pembelian sparepart & aksesoris pertamamu.
              </p>

              <button
                onClick={() => setStep(2)}
                className="bg-black text-white px-6 py-3 font-bold"
              >
                YA, SAYA INGIN →
              </button>
            </div>

            <div className="bg-red-600 text-white flex items-center justify-center font-bold text-2xl">
              SPAREPART <br /> & AKSESORIS
            </div>
          </>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <PromoForm
            onSubmit={(data) => {
              setFormData(data);
              setStep(3);
            }}
          />
        )}

        {/* STEP 3 */}
        {step === 3 && <PromoSuccess data={formData} />}
      </div>
    </div>
  );
};

export default PromoPopup;
